export const accessControl = {
  criarPedido: 163
}

export const vrAccessPermissionCodeMap: Record<string, number> = {
  F01: 153, // CriarEditarColaborador
  F02: 154, // TrocarColaboradorDeEmpresa
  F03: 155, // RemoverColaborador
  F04: 156, // PermissoesSistema
  F05: 157, // ImportarDemanda
  F06: 158, // ExportarDemanda
  F07: 160, // UsuariosSistema
  F08: 161, // CriarEditarUsuariosSistema
  F09: 163, // CriarPedido
  F10: 167, // Devolucoes
  F11: 169, // PortalABSCardVR
  F12: 170, // Relatorios
}
